// extracted by mini-css-extract-plugin
module.exports = {"docsSettings":"DocsSettings_docsSettings__zjMEn","section":"DocsSettings_section__D5RFX","bottomBorder":"DocsSettings_bottomBorder__44q5o"};